import { createSlice } from "@reduxjs/toolkit";
import { getLocationLogs, getLocationLogsNew, getReferralLogs } from "./thunk";

export interface IState {
  locationLogs: any;
  isLocationLogLoading: boolean;
  isLocationLogSuccess: boolean;

  referralLogs: any;
  isReferralLogLoading: boolean;
  isReferralLogSuccess: boolean;

  deletedLocationLogs: any;
  isDeletedLocationLogLoading: boolean;
  isDeletedLocationLogSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  locationLogs: null,
  isLocationLogLoading: false,
  isLocationLogSuccess: false,

  referralLogs: null,
  isReferralLogLoading: false,
  isReferralLogSuccess: false,

  deletedLocationLogs: null,
  isDeletedLocationLogLoading: false,
  isDeletedLocationLogSuccess: false,

  error: {},
};

const LocationLogSlice = createSlice({
  name: "LocationLog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get LocationLogs
    builder.addCase(getLocationLogs.pending, (state: IState, action: any) => {
      state.isLocationLogLoading = true;
    });
    builder.addCase(getLocationLogs.fulfilled, (state: IState, action: any) => {
      state.locationLogs = action.payload.data;
      state.isLocationLogSuccess = true;
      state.isLocationLogLoading = false;
    });
    builder.addCase(getLocationLogs.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isLocationLogSuccess = false;
      state.isLocationLogLoading = false;
    });

    //get ReferralLogs
    builder.addCase(getReferralLogs.pending, (state: IState, action: any) => {
      state.isReferralLogLoading = true;
    });
    builder.addCase(getReferralLogs.fulfilled, (state: IState, action: any) => {
      state.referralLogs = action.payload.data;
      state.isReferralLogSuccess = true;
      state.isReferralLogLoading = false;
    });
    builder.addCase(getReferralLogs.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isReferralLogSuccess = false;
      state.isReferralLogLoading = false;
    });
  },
});


const LocationLogNewSlice = createSlice({
  name: "LocationLogNew",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getLocationLogsNew.pending, (state: IState, action: any) => {
      state.isLocationLogLoading = true;
    });
    builder.addCase(getLocationLogsNew.fulfilled, (state: IState, action: any) => {
      state.locationLogs = action.payload.data;
      state.isLocationLogSuccess = true;
      state.isLocationLogLoading = false;
    });
    builder.addCase(getLocationLogsNew.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isLocationLogSuccess = false;
      state.isLocationLogLoading = false;
    });
  },
});

export default LocationLogSlice.reducer;
export const LocationLogNewReducer = LocationLogNewSlice.reducer;
